import * as React from "react";
import {
  Button,
  Card,
  Chip,
  Box,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  Stack,
  FormLabel,
  CircularProgress,
  NativeSelect,
  FormControl,
  InputLabel,
  Tab,
  Menu,
  Tooltip,
  Popover,
  TableCell,
  IconButton,
  Table,
  TableBody,
  TableRow,
  styled,
  tableCellClasses,
  Alert,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  GridColDef,
  GridFilterInputValueProps,
  GridFilterItem,
  GridFilterOperator,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid-pro";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import {
  useSetProductStatusMutation,
  useInventoryStockDecisionMutation,
  useGetSyncedProductsMutation,
  useGetDealerManufacturersQuery,
  addDealerManufacturers,
  useSetDmsSyncStatusMutation,
  useUpdateAggregatePriceMutation,
  useHidePricesInBulkMutation,
  useResetPriceSyncTypeMutation,
  useFetchBulkOperationStatusMutation,
} from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import {
  useRemoveBulkAggregateProductsMutation,
  useRevertShopifyCustomDetailsMutation,
} from "../../../redux/reducer/features/Product/productSlice";
import { AppState } from "../../../redux/reducer/rootReducer";
import Switch from "@mui/material/Switch";
import ServerAppGridPro from "../../app/ServerAppGridPro";
import { AppFilter } from "../../../models/app/AppModels";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import CardContent from "@mui/material/CardContent";
import {
  RequestFor,
  PricingType,
  ProductType,
} from "../../../models/features/Integration/DmsSetup";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useGetDmsManufacturersQuery } from "../../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { DmsManufacturer } from "../../../models/features/ShoppingPortal/DmsManufacturer";
import CloseIcon from "@mui/icons-material/Close";
import { AppGridId } from "../../../models/app/AppGridModels";
import {
  GetAppGridColumns,
  usePriceOptions,
  getSyncedVariantData,
  handleGetProductPrice,
  isValueNullOrZero,
  generatePriceIcons,
  formatDate,
  calculateGrossMargin,
  PRICING_WARNING_ICON,
  getProductRedirectUrl,
  filterColumnsBySetupType,
  IsShopifySetup,
  getCalculatedSalePrice,
} from "../../../services/utilities/utility";
import WarningIcon from "@mui/icons-material/Warning";
import {
  customPriceFilterOperators,
  booleanFilterOperators,
  syncTypeFilterOperators,
  matchingTypeFilterOperators,
  createLocationFilterOperators,
} from "../../app/CustomGridFilterOpereators";
import ShopifyProductDetails from "../../Used Products/ShopifyProductDetails";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SnackBarPopup from "../../app/SnackBarPopup";
import SyncDisabledIcon from "@mui/icons-material/SyncDisabled";
import SyncRoundedIcon from "@mui/icons-material/SyncRounded";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import PriceRule from "./Grids/PriceRule";
import { setBulkPriceSyncing } from "../../../redux/reducer/features/Auth/authSlice";
import {
  SetupType,
  PlatformFeature,
} from "../../../models/features/Integration/DmsSetup";
import { hasPlatformFeatureAccess } from "../../../services/featurePermissions/featureMatrix";
import {
  SubscriptionFeatureName,
  useHasSubscriptionFeature,
} from "../../../services/featurePermissions/subscriptionFeatures";
import TruncatedCellWithTooltip from "../../common/TruncatedCellWithTooltip";
import { useNavigate } from "react-router-dom";
import AppConfirmDialog from "../../app/AppConfirmDialog";
import { useApplyPromotionByIdMutation } from "../../../redux/reducer/features/Product/promotionSlice";
import dayjs from "dayjs";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "3px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
interface ProductManageProps {}

const ProductManagement: React.FunctionComponent<ProductManageProps> = () => {
  const navigate = useNavigate();
  const hasPriceLevels = useHasSubscriptionFeature(
    SubscriptionFeatureName.PriceLevels,
  );
  const hasWholegoods = useHasSubscriptionFeature(
    SubscriptionFeatureName.Wholegoods,
  );
  const hasParts = useHasSubscriptionFeature(SubscriptionFeatureName.Parts);
  const hasQohByLocation = useHasSubscriptionFeature(
    SubscriptionFeatureName.QohByLocation,
  );
  const WGgridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Product_Manager_Wholegoods,
    ),
  );
  const PartgridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Product_Manager_Parts,
    ),
  );
  const [value, setValue] = React.useState(
    hasWholegoods ? "Wholegoods" : "Parts",
  );
  const [wgPaging, setWgPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
    logicalOperator: "and",
  });
  const [partsPaging, setPartsPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
    logicalOperator: "and",
  });
  const paging = value === "Wholegoods" ? wgPaging : partsPaging;
  const setPaging = React.useCallback(
    (newPaging: AppFilter | ((prev: AppFilter) => AppFilter)) => {
      if (value === "Wholegoods") {
        setWgPaging(newPaging);
      } else {
        setPartsPaging(newPaging);
      }
    },
    [value, setWgPaging, setPartsPaging],
  );

  const productTypes = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.productTypes,
  );
  const locations = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.dmsLocations,
  );
  const priceOptions = usePriceOptions();
  const [filteredManufacturers, setFilteredManufacturers] = React.useState<
    DmsManufacturer[]
  >([]);
  const dispatch = useDispatch();
  const [products, setProducts] = React.useState<any[]>([]);
  const [productsCount, setProductsCount] = React.useState<number>(0);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [selectedRowData, setSelectedRowData] = React.useState<any>();
  const [open, setOpen] = React.useState(false);
  const [isResetRequest, setIsResetRequest] = React.useState(false);
  const [openPrices, setOpenPrices] = React.useState(false);
  const [openPriceRule, setOpenPriceRule] = React.useState(false);
  const [openHidePrice, setOpenHidePrice] = React.useState(false);
  const [isOperationRunning, setIsOperationRunning] = React.useState(false);
  const [hideValue, setHideValue] = React.useState(false);
  const [priceType, setPriceType] = React.useState<PricingType>();
  const [productType, setProductType] = React.useState(0);
  const [openStockForm, setOpenStockForm] = React.useState(false);
  const [checked, setChecked] = React.useState(true);
  const [openShopifyDetails, setOpenShopifyDetails] = React.useState(false);
  const [openRevertCustom, setOpenRevertCustom] = React.useState(false);
  const [showSaveAlert, setShowSaveAlert] = React.useState(false);
  const [showAlertMessage, setShowAlertMessage] = React.useState("");
  const [productDeleteConfirm, setProductDeleteConfirm] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [openResetPrice, setOpenResetPrice] = React.useState(false);
  const [locationPopoverAnchorEl, setLocationPopoverAnchorEl] =
    React.useState<HTMLElement | null>(null);
  const [locationPopoverStocks, setLocationPopoverStocks] = React.useState<
    Array<{ name: string; stock: number }>
  >([]);
  const [onPromotionConfirm, setOnPromotionConfirm] = React.useState<
    (() => void) | null
  >(null);
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const { data: dmsManufacturersList } = useGetDmsManufacturersQuery({
    dealerId: locations ? (locations[0].dealerId.toString() ?? "") : "",
  });

  const manufacturersQuery = useGetDealerManufacturersQuery({});
  var priceTag =
    dmsSetup?.dmsLocations[0].dmsType === 0 ? "web price" : "price level";
  const [syncProduct, syncProductResult] = useGetSyncedProductsMutation();
  const [setSyncStatusMutation, setSyncStatusMutationResult] =
    useSetDmsSyncStatusMutation();
  const [setProductStatusMutation, setProductStatusMutationResult] =
    useSetProductStatusMutation();
  const [setStockDecision, setStockDecisionMutationResult] =
    useInventoryStockDecisionMutation();
  const [setStockDecisionByItem, setStockDecisionByItemMutationResult] =
    useInventoryStockDecisionMutation();
  const [deleteBulkProductsMutation, deleteBulkProductsMutationResult] =
    useRemoveBulkAggregateProductsMutation();
  const [updatePriceMutation, updatePriceMutationResult] =
    useUpdateAggregatePriceMutation();
  const [hidePriceMutation, hidePriceMutationMutationResult] =
    useHidePricesInBulkMutation();
  const [revertCustomDetailsMutation, revertCustomDetailsMutationResult] =
    useRevertShopifyCustomDetailsMutation();
  const [resetPriceSyncMutation, resetPriceSyncMutationResult] =
    useResetPriceSyncTypeMutation();
  const [
    fetchBulkOperationStatusMutation,
    fetchBulkOperationStatusMutationResult,
  ] = useFetchBulkOperationStatusMutation();
  const hasPromotionsSubscription = useHasSubscriptionFeature(
    SubscriptionFeatureName.WebPromotions,
  );
  const [deleteConfirm, setDeleteConfirm] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorAction, setAnchorAction] = React.useState<null | HTMLElement>(
    null,
  );
  const openPriceMenu = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  React.useEffect(() => {
    if (
      dmsSetup?.isWholegoodBulkPriceSyncing === false &&
      productType === 0 &&
      !syncProductResult.isLoading
    ) {
      fetchData();
    }
    if (
      dmsSetup?.isPartsBulkPriceSyncing === false &&
      productType === 1 &&
      !syncProductResult.isLoading
    ) {
      fetchData();
    }
  }, [
    dmsSetup?.isWholegoodBulkPriceSyncing,
    dmsSetup?.isPartsBulkPriceSyncing,
  ]);

  React.useEffect(() => {
    if (!dmsSetup) return;

    let intervalId: ReturnType<typeof setInterval> | undefined;

    const isSyncing =
      dmsSetup.isWholegoodBulkPriceSyncing || dmsSetup.isPartsBulkPriceSyncing;

    if (isSyncing) {
      const fetchStatus = async () => {
        try {
          const res: any = await fetchBulkOperationStatusMutation(null);
          if (res.data?.status === 200 && res.data.entity === false) {
            clearInterval(intervalId);
            intervalId = undefined;
            dispatch(
              setBulkPriceSyncing({
                isSyncing: false,
                productType: ProductType.Wholegoods,
              }),
            );
            dispatch(
              setBulkPriceSyncing({
                isSyncing: false,
                productType: ProductType.Parts,
              }),
            );
          }
        } catch (error) {
          console.error("Error checking sync status:", error);
        }
      };

      fetchStatus();
      intervalId = setInterval(fetchStatus, 30000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [
    dmsSetup?.isWholegoodBulkPriceSyncing,
    dmsSetup?.isPartsBulkPriceSyncing,
  ]);

  const handleUpdatePrice = (
    priceType: PricingType,
    price: any,
    compareAtPrice: number,
  ) => {
    setPriceType(priceType);
    setIsResetRequest(isResetRequest);
    updatePriceMutation({
      aggregateId: selectedRowData?.id ?? "",
      externalProductId: selectedRowData?.externalProductId ?? "",
      variantId: selectedRowData?.variantId ?? 0,
      hasActivePromotion: selectedRowData?.activePromotion ? true : false,
      activePromotion: selectedRowData?.activePromotion,
      price: price,
      aggregatePriceType: priceType,
      compareAtPrice: compareAtPrice,
    }).then((res: any) => {
      if (res.data && res.data.status === 200) {
        fetchData();
        setOpenPrices(false);
        setIsResetRequest(false);
      }
    });
  };

  React.useEffect(() => {
    if (
      dmsManufacturersList?.entityList &&
      dmsManufacturersList.entityList?.length > 0
    ) {
      setFilteredManufacturers(dmsManufacturersList.entityList);
    }
  }, [dmsManufacturersList]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    if (newValue === "Wholegoods") {
      setProductType(0);
    } else {
      setProductType(1);
    }
  };
  const handleDecisionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleDecisionChangeSingleItem = (product: any, checked: boolean) => {
    setProducts(
      products.map((item) =>
        item.id === product.productAggId
          ? {
              ...item,
              externalProduct: {
                ...item.externalProduct,
                variants: [
                  {
                    ...item.externalProduct.variants[0],
                    outStockSelling: checked,
                  },
                ],
              },
            }
          : item,
      ),
    );

    handleStockDecisionSubmitByItem(product, checked ? "yes" : "no");
  };
  const handleClose = () => {
    setAnchorAction(null);
    setLocationPopoverAnchorEl(null);
    setOpenShopifyDetails(false);
    setOpen(false);
    setOpenPrices(false);
    setOpenPriceRule(false);
    setAnchorEl(null);
    setOpenStockForm(false);
    setDeleteConfirm(false);
    setOpenHidePrice(false);
    setOpenRevertCustom(false);
    setProductDeleteConfirm(false);
    setOpenResetPrice(false);
  };
  const getLocationStocks = React.useCallback(
    (row: any) => {
      const availableLocations = (locations ?? []).filter(
        (location: any) => location.storeLocationId > 0,
      );

      return availableLocations
        .map((location: any) => {
          const locationStock = row?.stock?.find(
            (stockItem: any) => stockItem.dmsLocationId === location.id,
          );
          return {
            name: location.name,
            stock: locationStock?.stock ?? 0,
          };
        })
        .filter((locationStock) => locationStock?.stock > 0);
    },
    [locations],
  );
  const handleOpenLocationPopover = (
    event: React.MouseEvent<HTMLElement>,
    row: any,
  ) => {
    setLocationPopoverAnchorEl(event.currentTarget);
    setLocationPopoverStocks(getLocationStocks(row));
  };
  const handleCloseLocationPopover = () => {
    setLocationPopoverAnchorEl(null);
    setLocationPopoverStocks([]);
  };
  const renderLocationChips = (params: GridRenderCellParams) => {
    const locationStocks = getLocationStocks(params.row);

    const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
      const container = event.currentTarget;
      const startX = event.pageX;
      const startScrollLeft = container.scrollLeft;

      container.style.cursor = "grabbing";
      container.style.userSelect = "none";

      const handleMouseMove = (moveEvent: MouseEvent) => {
        const deltaX = moveEvent.pageX - startX;
        container.scrollLeft = startScrollLeft - deltaX;
      };

      const handleMouseUp = () => {
        container.style.cursor = "grab";
        container.style.removeProperty("user-select");
        window.removeEventListener("mousemove", handleMouseMove);
        window.removeEventListener("mouseup", handleMouseUp);
      };

      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    };

    if (!locationStocks.length) return null;

    return (
      <Box
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          gap: 0.5,
          py: 0.5,
          overflowX: "auto",
          whiteSpace: "nowrap",
          cursor: "grab",
          scrollbarWidth: "none",
        }}
        onMouseDown={handleMouseDown}
      >
        {locationStocks.map((locationStock, index: number) => (
          <Chip
            key={`${index}`}
            label={`${locationStock.name} : ${locationStock.stock}`}
            size="small"
            color="default"
            clickable
            onClick={(event) => handleOpenLocationPopover(event, params.row)}
            sx={{ cursor: "pointer" }}
          />
        ))}
      </Box>
    );
  };
  const handleClosePriceRule = (refreshData: boolean) => {
    setAnchorEl(null);
    setOpenPriceRule(false);
    if (refreshData) {
      fetchData();
    }
  };
  const handleGetRowColor = (price: PricingType) => {
    let color = "";
    if (
      selectedRowData?.priceType === PricingType[price] &&
      !selectedRowData?.activePromotion
    ) {
      color = "rgb(237, 247, 237)";
    }
    return color;
  };
  const handleRevertCustomDetails = () => {
    revertCustomDetailsMutation({ aggregateId: selectedRowData?.id }).then(
      (res: any) => {
        if (res.data && res.data.status === 200) {
          fetchData();
          setOpenRevertCustom(false);
        }
      },
    );
  };

  const handleDeleteProduct = () => {
    deleteBulkProductsMutation({
      ProductAggregateIds: [selectedRowData.id],
    }).then((res: any) => {
      if (res.data && res.data.status === 200) {
        fetchData();
        setProductDeleteConfirm(false);
      }
    });
  };
  const handleResetPrice = () => {
    setErrorMessage("");
    resetPriceSyncMutation({
      pricing:
        value === "Wholegoods"
          ? (dmsSetup?.priceType ?? PricingType.Price)
          : (dmsSetup?.partsPriceType ?? PricingType.Price),
      productType: productType,
      productIds: selectedRows,
    }).then((res: any) => {
      if (res?.data && res?.data?.status === 200) {
        handleClose();
        fetchData();
      } else {
        if (res?.data && res?.data?.status === 208) {
          setErrorMessage(
            "A bulk operation for price updates is already running. Please wait for a while to complete it!",
          );
        } else if (res?.data?.status === 400) {
          setErrorMessage(
            "Found error while updating prices. Please contact to the support!",
          );
        } else handleClose();
      }
    });
  };
  function RatingInputValue(props: GridFilterInputValueProps) {
    const { item, applyValue, focusElementRef } = props;

    const ratingRef: React.Ref<any> = React.useRef(null);

    const handleDropdownFilterChange = (event: any) => {
      applyValue({
        ...item,
        value: event.target.value !== "all" ? event.target.value : undefined,
      });
    };
    return (
      <FormControl fullWidth>
        <InputLabel variant="standard" htmlFor="uncontrolled-native" shrink>
          Manufacturer
        </InputLabel>
        <NativeSelect
          ref={ratingRef}
          value={item.value ?? ""}
          inputProps={{
            name: "age",
            id: "uncontrolled-native",
          }}
          onChange={handleDropdownFilterChange}
        >
          <option value={""} disabled>
            Select
          </option>
          {filteredManufacturers
            .filter((m) =>
              productType === 0
                ? m.isWholegoodManufacturer
                : m.isPartManufacturer,
            )
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((n) => (
              <option key={n.code} value={n.code}>
                {n.name}
              </option>
            ))}
        </NativeSelect>
      </FormControl>
    );
  }
  const handleUpdateProductMatchingType = (productId: string, type: string) => {
    setProducts(
      products.map((item) =>
        item.id === productId
          ? {
              ...item,
              matchingType: type,
            }
          : item,
      ),
    );
  };
  const ratingOnlyOperators: GridFilterOperator[] = [
    {
      label: "Equals",
      value: "equals",
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (
          !filterItem.columnField ||
          !filterItem.value ||
          !filterItem.operatorValue
        ) {
          return null;
        }

        return (params): boolean => {
          return params.value == filterItem.value;
        };
      },
      InputComponent: RatingInputValue,
      InputComponentProps: { type: "number" },
    },
  ];
  const getPriceIcon = (product?: any): React.ReactNode => {
    if (
      !product?.aggregatePrices &&
      (product?.price == null || product?.price === 0)
    ) {
      return (
        <Tooltip title="This product does not have any price data.">
          <WarningIcon color="error" fontSize="small" />
        </Tooltip>
      );
    }

    // 1) Price sync must be enabled
    if (!product.enablePriceSync) {
      return (
        <Tooltip title="Price sync is off for this product.">
          <SyncDisabledIcon color="error" />
        </Tooltip>
      );
    }

    // 2) Promotion trumps everything
    if (product.activePromotion) {
      return (
        <Tooltip title="There is an ongoing promotion for this product.">
          <PriceChangeOutlinedIcon color="success" />
        </Tooltip>
      );
    }

    // 5) Map enum value -> enum name string (e.g. PriceLevel1)
    const priceTypeName =
      PricingType[product.priceType as keyof typeof PricingType];

    // 6) Find the priceOptions entry that tells us which aggregatePrices key to use
    const priceOption = priceOptions.find((p) => p.type === priceTypeName);

    const resolvedPrice = product?.aggregatePrices[priceOption?.key ?? "price"];
    if (resolvedPrice == null || resolvedPrice === 0)
      return PRICING_WARNING_ICON;

    if (!hasPriceLevels) return null;
    return generatePriceIcons(product.priceType, priceTag);
  };
  const columns: GridColDef[] = [
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      width: 200,
      filterOperators: ratingOnlyOperators,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row.manufacturer}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.manufacturer}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "model",
      headerName: "MPN",
      width: 180,
      renderHeader: () => (
        <Tooltip title="Manufacturer Product Number">
          <Typography sx={{ fontSize: "0.875rem", fontWeight: 500 }}>
            MPN
          </Typography>
        </Tooltip>
      ),
      renderCell: (params: GridRenderCellParams) => {
        return <TruncatedCellWithTooltip value={params.row.model} />;
      },
    },
    {
      field: "title",
      headerName: "Title",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <TruncatedCellWithTooltip
            value={
              params.row?.externalProduct
                ? params.row.externalProduct?.title
                : params.row.title
            }
          />
        );
      },
    },
    {
      field: "category",
      headerName: "Category",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row?.category ?? "N/A"}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row?.category ?? "N/A"}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      width: 100,
      align: "right",
      type: "number",
      filterOperators: customPriceFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "price",
      headerName: "MSRP ($)",
      headerAlign: "right",
      width: 120,
      filterOperators: customPriceFilterOperators,
      type: "number",
      align: "right",
      sortable: true,
      valueGetter: (params: GridValueGetterParams<any>) => {
        return params?.row?.price.toFixed(2) ?? 0.0;
      },
    },
    {
      field: "grossMargin",
      headerName: "Gross Margin (%)",
      sortable: false,
      renderHeader: () => (
        <Tooltip title="Gross Margin = ((Web Price - Cost) / Web Price ) * 100">
          <span>Gross Margin (%)</span>
        </Tooltip>
      ),
      headerAlign: "right",
      width: 130,
      type: "number",
      align: "right",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        const cost = Number(params.row.cost) || 0;
        const externalPrice = params.row.externalProduct
          ? Number(getSyncedVariantData(params.row)?.price) || 0
          : 0;
        return calculateGrossMargin(cost, externalPrice);
      },
    },
    {
      field: "storeprice",
      headerName: "Web Price ($)",
      headerAlign: "right",
      width: 130,
      align: dmsSetup?.isWholegoodBulkPriceSyncing ? "center" : "right",
      type: "number",
      filterable: false,
      sortable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.externalProduct
          ? getSyncedVariantData(params.row)?.price?.toFixed(2)
          : "0.00",
      renderCell: (params) => {
        return (
          <>
            {dmsSetup?.isWholegoodBulkPriceSyncing ? (
              <Tooltip title="A bulk price update is in progress. Please wait until it is completed.">
                <SyncRoundedIcon fontSize="small" color="primary" />
              </Tooltip>
            ) : (
              <>
                {params.row?.externalProduct?.isPriceHidden && (
                  <Tooltip title="The price of this product is hidden on Website.">
                    <WarningIcon fontSize="small" color="warning" />
                  </Tooltip>
                )}
                <Button
                  onClick={() => {
                    setSelectedRowData(params.row);
                    setOpenPrices(hasPriceLevels);
                  }}
                >
                  {params.value}
                </Button>
                {getPriceIcon(params.row)}
              </>
            )}
          </>
        );
      },
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      width: 70,
      align: "right",
      type: "number",
      filterOperators: customPriceFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.stock) {
          return params.row?.stock?.reduce(
            (partial: number, value: any) => partial + value.stock,
            0,
          );
        }
      },
      renderCell: (params: GridRenderCellParams) => {
        var stock = params.row?.stock?.reduce(
          (partial: number, value: any) => partial + value.stock,
          0,
        );
        const hasStoreLocation =
          locations && locations.some((l) => l.storeLocationId > 0);
        if (!hasStoreLocation) return null;
        return hasQohByLocation ? (
          <Tooltip
            title={
              <>
                {locations!
                  .filter((l) => l.storeLocationId > 0)
                  .map((e, index: number) => {
                    var locationStock = params.row?.stock.find(
                      (n: any) => n.dmsLocationId === e.id,
                    );
                    return (
                      <Typography key={index}>
                        {e.name}: {locationStock?.stock ?? 0}
                      </Typography>
                    );
                  })}
              </>
            }
          >
            <Typography
              sx={{
                cursor: "pointer",
                fontSize: "inherit",
                lineHeight: "inherit",
                letterSpacing: "inherit",
              }}
            >
              {stock}
            </Typography>
          </Tooltip>
        ) : (
          <Typography
            sx={{
              fontSize: "inherit",
              lineHeight: "inherit",
              letterSpacing: "inherit",
            }}
          >
            {stock}
          </Typography>
        );
      },
    },
    {
      field: "storeStock",
      headerName: "Online Stock",
      headerAlign: "right",
      width: 100,
      align: "right",
      type: "number",
      filterable: false,
      sortable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.externalProduct
          ? getSyncedVariantData(params.row)?.stock
          : "0",
      renderCell: (params) => params.value,
    },
    {
      field: "location",
      headerName: "Location",
      renderHeader: () => "Locations",
      width: 180,
      sortable: false,
      filterable: true,
      filterOperators: createLocationFilterOperators(
        (locations ?? [])
          .filter((l: any) => l.storeLocationId > 0)
          .map((l: any) => ({ id: l.id, name: l.name })),
      ),
      renderCell: (params: GridRenderCellParams) => {
        return renderLocationChips(params);
      },
    },
    {
      field: "outOfStock",
      headerName: "OutStock Selling",
      type: "actions",
      width: 130,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row?.externalProduct ? (
          <Switch
            size="small"
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.externalProduct.variants[0].outStockSelling}
            name="status"
            onChange={(e) => {
              handleDecisionChangeSingleItem(
                {
                  shopifyProductId: params.row?.externalProductId,
                  productAggId: params.row?.id,
                  variantId: params.row?.variantId,
                },
                e.target.checked,
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        ) : (
          ""
        );
      },
    },
    {
      field: "disableStockSync",
      headerName: "Stock Sync",
      type: "actions",
      width: 100,
      filterable: true,
      filterOperators: booleanFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row?.enableStockSync,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            size="small"
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.enableStockSync}
            name="status"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                RequestFor.Stock,
                e.target.checked,
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "disablePriceSync",
      headerName: "Price Sync",
      type: "actions",
      width: 100,
      filterable: true,
      filterOperators: booleanFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row?.enablePriceSync,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            size="small"
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.enablePriceSync}
            name="status"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                RequestFor.Price,
                e.target.checked,
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "enableCatalogSync",
      headerName: "Catalog Sync",
      type: "actions",
      width: 110,
      filterable: true,
      filterOperators: booleanFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row?.enableCatalogSync,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            size="small"
            checked={
              params.row?.matchingType === "Custom" ||
              params.row?.matchingType === "DMS"
                ? false
                : params.row?.enableCatalogSync
            }
            disabled={
              params.row?.matchingType === "Custom" ||
              params.row?.matchingType === "DMS"
            }
            name="status"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                RequestFor.Catalog,
                e.target.checked,
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      align: "center",
      headerAlign: "center",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return getStatusChip(params.row);
      },
    },
    {
      field: "isExistingProduct",
      headerName: "Sync Type",
      headerAlign: "center",
      width: 100,
      align: "center",
      type: "boolean",
      filterable: true,
      filterOperators: syncTypeFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row?.isExistingProduct,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.isExistingProduct ? (
          <Chip label="Reverse" color="warning" size="small" />
        ) : (
          <Chip label="Regular" color="success" size="small" />
        );
      },
    },
    {
      field: "type",
      headerName: "Matching Type",
      width: 120,
      align: "center",
      headerAlign: "center",
      filterable: true,
      filterOperators: matchingTypeFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row?.matchingType,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.matchingType === "Catalog" ? (
          <Chip label="Catalog" color="success" size="small" />
        ) : params.row.matchingType === "DMS" ? (
          <Chip label="DMS" color="warning" size="small" />
        ) : (
          <Chip label="Custom" color="info" size="small" />
        );
      },
    },
    {
      field: "actions",
      headerName: "View / Edit",
      type: "actions",
      sortable: false,
      // width: 80,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <Chip
              label="Action"
              color="info"
              size="small"
              onClick={(event) => {
                setSelectedRowData(params.row);
                setAnchorAction(event.currentTarget);
              }}
            />
            <Menu
              anchorEl={anchorAction}
              open={Boolean(anchorAction)}
              onClose={handleClose}
            >
              {hasPlatformFeatureAccess(
                dmsSetup?.setupType,
                PlatformFeature.ExternalProductActions,
              ) && (
                <>
                  <MenuItem
                    onClick={() => {
                      window.open(
                        getProductRedirectUrl(
                          dmsSetup?.siteDomain ?? "",
                          selectedRowData?.externalProductLink,
                          dmsSetup?.setupType ?? SetupType.Shopify,
                        ),
                        "_blank",
                      );
                      setAnchorAction(null);
                    }}
                  >
                    <ListItemIcon>
                      <VisibilityIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>View in site</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setOpenShopifyDetails(true);
                      setAnchorAction(null);
                    }}
                  >
                    <ListItemIcon>
                      <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Edit</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setProductDeleteConfirm(true);
                      setAnchorAction(null);
                    }}
                  >
                    <ListItemIcon>
                      <DeleteForeverIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Delete</ListItemText>
                  </MenuItem>
                  <MenuItem
                    sx={{
                      display: IsShopifySetup(dmsSetup?.setupType)
                        ? ""
                        : "none",
                    }}
                    disabled={
                      selectedRowData?.matchingType !== "Custom" ||
                      !selectedRowData.productId
                    }
                    onClick={() => {
                      setOpenRevertCustom(true);
                      setAnchorAction(null);
                    }}
                  >
                    <ListItemIcon>
                      <ManageHistoryIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Use Catalog</ListItemText>
                  </MenuItem>
                </>
              )}
            </Menu>
          </>
        );
      },
    },
  ];
  const partsColumns: GridColDef[] = [
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      width: 200,
      filterOperators: ratingOnlyOperators,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row.manufacturer}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.manufacturer}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "partNumber",
      headerName: "Part Number",
      width: 200,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.partNumber,
    },
    {
      field: "title",
      headerName: "Title",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <TruncatedCellWithTooltip
            value={
              params.row?.externalProduct
                ? params.row.externalProduct?.title
                : params.row.title
            }
          />
        );
      },
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      width: 100,
      align: "right",
      type: "number",
      filterOperators: customPriceFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "price",
      headerName: "MSRP ($)",
      headerAlign: "right",
      width: 120,
      filterOperators: customPriceFilterOperators,
      type: "number",
      align: "right",
      sortable: true,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "grossMargin",
      headerName: "Gross Margin (%)",
      sortable: false,
      renderHeader: () => (
        <Tooltip title="Gross Margin = ((Web Price - Cost) / Web Price ) * 100">
          <span>Gross Margin (%)</span>
        </Tooltip>
      ),
      headerAlign: "right",
      width: 130,
      type: "number",
      align: "right",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        const cost = Number(params.row.cost) || 0;
        const externalPrice = params.row.externalProduct
          ? Number(getSyncedVariantData(params.row)?.price) || 0
          : 0;
        return calculateGrossMargin(cost, externalPrice);
      },
    },
    {
      field: "storeprice",
      headerName: "Web Price ($)",
      headerAlign: "right",
      width: 130,
      align: dmsSetup?.isPartsBulkPriceSyncing ? "center" : "right",
      type: "number",
      filterable: false,
      sortable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.externalProduct
          ? getSyncedVariantData(params.row)?.price?.toFixed(2)
          : "0.00",
      renderCell: (params) => {
        return (
          <>
            {dmsSetup?.isPartsBulkPriceSyncing ? (
              <Tooltip title="A bulk price update is in progress. Please wait until it is completed.">
                <SyncRoundedIcon fontSize="small" sx={{ color: "black" }} />
              </Tooltip>
            ) : (
              <>
                {params.row?.externalProduct?.isPriceHidden && (
                  <Tooltip title="The price of this product is hidden on Website.">
                    <WarningIcon fontSize="small" color="warning" />
                  </Tooltip>
                )}
                <Button
                  onClick={() => {
                    setSelectedRowData(params.row);
                    setOpenPrices(hasPriceLevels);
                  }}
                >
                  {params.value}
                </Button>
                {getPriceIcon(params.row)}
              </>
            )}
          </>
        );
      },
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      width: 70,
      align: "right",
      type: "number",
      filterOperators: customPriceFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.stock) {
          return params.row?.stock?.reduce(
            (partial: number, value: any) => partial + value.stock,
            0,
          );
        }
      },
      renderCell: (params: GridRenderCellParams) => {
        var stock = params.row?.stock?.reduce(
          (partial: number, value: any) => partial + value.stock,
          0,
        );
        const hasStoreLocation =
          locations && locations.some((l) => l.storeLocationId > 0);
        if (!hasStoreLocation) return null;
        return hasQohByLocation ? (
          <Tooltip
            title={
              <>
                {locations!
                  .filter((l) => l.storeLocationId > 0)
                  .map((e, index: number) => {
                    var locationStock = params.row?.stock.find(
                      (n: any) => n.dmsLocationId === e.id,
                    );
                    return (
                      <Typography key={index}>
                        {e.name}: {locationStock?.stock ?? 0}
                      </Typography>
                    );
                  })}
              </>
            }
          >
            <Typography
              sx={{
                cursor: "pointer",
                fontSize: "inherit",
                lineHeight: "inherit",
                letterSpacing: "inherit",
              }}
            >
              {stock}
            </Typography>
          </Tooltip>
        ) : (
          <Typography
            sx={{
              fontSize: "inherit",
              lineHeight: "inherit",
              letterSpacing: "inherit",
            }}
          >
            {stock}
          </Typography>
        );
      },
    },
    {
      field: "location",
      headerName: "Location",
      renderHeader: () => "Locations",
      width: 180,
      sortable: false,
      filterable: true,
      filterOperators: createLocationFilterOperators(
        (locations ?? [])
          .filter((l: any) => l.storeLocationId > 0)
          .map((l: any) => ({ id: l.id, name: l.name })),
      ),
      renderCell: (params: GridRenderCellParams) => {
        return renderLocationChips(params);
      },
    },

    {
      field: "outOfStock",
      headerName: "OutStock Selling",
      type: "actions",
      width: 130,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row?.externalProduct ? (
          <Switch
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.externalProduct.variants[0].outStockSelling}
            name="status"
            size="small"
            onChange={(e) => {
              handleDecisionChangeSingleItem(
                {
                  shopifyProductId: params.row?.externalProductId,
                  productAggId: params.row?.id,
                  variantId: params.row?.variantId,
                },
                e.target.checked,
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        ) : (
          ""
        );
      },
    },
    {
      field: "disableStockSync",
      headerName: "Stock Sync",
      type: "actions",
      width: 100,
      filterable: true,
      filterOperators: booleanFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row?.enableStockSync,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.enableStockSync}
            name="status"
            size="small"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                RequestFor.Stock,
                e.target.checked,
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "disablePriceSync",
      headerName: "Price Sync",
      type: "actions",
      width: 100,
      filterable: true,
      filterOperators: booleanFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row?.enablePriceSync,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.enablePriceSync}
            name="status"
            size="small"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                RequestFor.Price,
                e.target.checked,
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      align: "center",
      headerAlign: "center",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return getStatusChip(params.row);
      },
    },
    {
      field: "isExistingProduct",
      headerName: "Sync Type",
      headerAlign: "center",
      width: 100,
      align: "center",
      type: "boolean",
      filterable: true,
      filterOperators: syncTypeFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row?.isExistingProduct,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.isExistingProduct ? (
          <Chip label="Reverse" color="warning" size="small" />
        ) : (
          <Chip label="Regular" color="success" size="small" />
        );
      },
    },
    {
      field: "type",
      headerName: "Matching Type",
      width: 120,
      align: "center",
      headerAlign: "center",
      filterable: true,
      filterOperators: matchingTypeFilterOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row?.matchingType,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.matchingType === "DMS" ? (
          <Chip label="DMS" color="warning" size="small" />
        ) : (
          <Chip label="Custom" color="info" size="small" />
        );
      },
    },
    {
      field: "actions",
      headerName: "View / Edit",
      type: "actions",
      sortable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <Chip
              label="Action"
              color="info"
              size="small"
              onClick={(event) => {
                setSelectedRowData(params.row);
                setAnchorAction(event.currentTarget);
              }}
            />
            <Menu
              anchorEl={anchorAction}
              open={Boolean(anchorAction)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  window.open(
                    getProductRedirectUrl(
                      dmsSetup?.siteDomain ?? "",
                      selectedRowData?.externalProductLink,
                      dmsSetup?.setupType ?? SetupType.Shopify,
                    ),
                    "_blank",
                  );
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <VisibilityIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>View in site</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setOpenShopifyDetails(true);
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setProductDeleteConfirm(true);
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <DeleteForeverIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Delete</ListItemText>
              </MenuItem>
            </Menu>
          </>
        );
      },
    },
  ];

  const getStatusChip = (product: any) => {
    if (
      product?.externalProduct &&
      product.externalProduct.status.toLowerCase() === "active"
    )
      return (
        <Chip
          sx={{ cursor: "pointer" }}
          label="Active"
          onDelete={() =>
            handleShowHideSubmit(product.id, product.externalProductId, "hide")
          }
          color="success"
          disabled={setProductStatusMutationResult.isLoading}
          size="small"
        />
      );
    else
      return (
        <Chip
          onDelete={() =>
            handleShowHideSubmit(product.id, product.externalProductId, "show")
          }
          disabled={setProductStatusMutationResult.isLoading}
          label="Draft"
          color="error"
          size="small"
        />
      );
  };

  React.useEffect(() => {
    fetchData();
  }, [paging, productType]);

  const fetchData = () => {
    syncProduct({
      setupId: dmsSetup?.id ?? "",
      paging: paging,
      productType: productType,
    });
  };

  React.useEffect(() => {
    if (syncProductResult.data) {
      setProducts(syncProductResult.data.entityList);
      setProductsCount(syncProductResult.data.totalRecords);
    }
  }, [syncProductResult]);

  const handleShowHideSubmit = (
    aggregateId: string,
    shopifyProductId: number,
    action: string,
  ) => {
    let selectedItems = [
      { shopifyProductId: shopifyProductId, productAggId: aggregateId },
    ];
    setProductStatusMutation({
      products: selectedItems,
      decision: action,
      setupType: dmsSetup?.setupType ?? SetupType.Shopify,
    }).then((res: any) => {
      if (res && res.data.status === 0) {
        setProducts(
          products.map((x) =>
            x.id === aggregateId
              ? {
                  ...x,
                  externalProduct: {
                    ...x.externalProduct,
                    status: action === "show" ? "ACTIVE" : "DRAFT",
                  },
                }
              : x,
          ),
        );
      }
    });
  };

  const handleDeleteSubmit = async () => {
    let selectedItems = getSelectedRowData();
    const ids = selectedItems.map((n: any) => n.productAggId);
    deleteBulkProductsMutation({
      ProductAggregateIds: ids,
    }).then((res: any) => {
      if (res && res.data) {
        setDeleteConfirm(false);
        setSelectedRows([]);
        fetchData();
      }
    });
  };

  const handleHidePrice = () => {
    let selectedItems = getSelectedRowData();
    if (selectedItems && selectedItems.length > 0) {
      let externalProductIds = selectedItems.map(
        (item: any) => item.externalProductId,
      );
      hidePriceMutation({
        externalProductIds: externalProductIds,
        hidePrice: hideValue,
      }).then((res: any) => {
        if (res && res.data) {
          if (res.data.status === 200) {
            setAnchorEl(null);
            setOpenHidePrice(false);
            setSelectedRows([]);
            fetchData();
          } else if (res.data.status === 208) {
            setIsOperationRunning(true);
          }
        }
      });
    }
  };
  const hasHiddenPriceProduct = (): boolean => {
    const filteredProducts = products.filter((product: any) =>
      selectedRows.includes(product.id),
    );
    return filteredProducts.some((product: any) => {
      return product?.externalProduct?.isPriceHidden ?? false;
    });
  };

  const hasNotHiddenPriceProduct = (): boolean => {
    const filteredProducts = products.filter((product: any) =>
      selectedRows.includes(product.id),
    );
    return filteredProducts.some((product: any) => {
      return !(product?.externalProduct?.isPriceHidden ?? false);
    });
  };

  const handleStockDecisionSubmit = () => {
    let selectedItems = getSelectedRowData();
    selectedItems = selectedItems.map((item: any) => ({
      productAggId: item.productAggId,
      shopifyProductId: item.externalProductId,
    }));
    setStockDecision({
      products: selectedItems,
      decision: checked ? "yes" : "no",
    }).then((res: any) => {
      setOpenStockForm(false);
      fetchData();
    });
  };

  const handleStockDecisionSubmitByItem = (product: any, decision: string) => {
    setStockDecisionByItem({
      products: [
        {
          productAggId: product.productAggId,
          variantId: product.variantId,
          shopifyProductId: product.shopifyProductId,
        },
      ],
      decision: decision,
    });
  };
  const getSelectedRowData = () => {
    return selectedRows.map((rowId: any) => {
      let item = products.find((n) => n.id === rowId);

      if (item) {
        return {
          externalProductId: item.externalProductId,
          productAggId: rowId,
        };
      }
    });
  };

  React.useEffect(() => {
    if (manufacturersQuery.data) {
      const filteredDmsManufacturers =
        manufacturersQuery.data.entityList?.map((mfr) =>
          !mfr.name?.trim()
            ? {
                ...mfr,
                name:
                  dmsManufacturersList?.entityList?.find(
                    (dmsMfr) =>
                      dmsMfr.code === mfr.code &&
                      dmsMfr.manufacturerId === mfr.manufacturerId,
                  )?.name || mfr.code,
              }
            : mfr,
        ) || [];
      setFilteredManufacturers(filteredDmsManufacturers);
    }
  }, [manufacturersQuery.data, dmsManufacturersList]);

  const getIconImageUrl = (imgUrl: string) => {
    if (!imgUrl) return imgUrl;
    // Shopify
    if (dmsSetup?.setupType === SetupType.Shopify) {
      const urlWithoutQuery = imgUrl.split("?")[0];
      const lastDotIndex = urlWithoutQuery.lastIndexOf(".");
      if (lastDotIndex === -1) return imgUrl;

      const base = urlWithoutQuery.slice(0, lastDotIndex);
      const ext = urlWithoutQuery.slice(lastDotIndex);

      return `${base}_350x350${ext}`;
    }

    // BigCommerce
    if (dmsSetup?.setupType === SetupType.BigCommerce) {
      const separator = imgUrl.includes("?") ? "&" : "?";
      return `${imgUrl}${separator}w=350&h=350&c=1`;
    }

    // Fallback
    return imgUrl;
  };

  const handleAggregateSyncStatus = (
    id: string,
    enableOption: RequestFor,
    isEnable: boolean,
  ) => {
    setSyncStatusMutation({
      request: {
        aggregateId: id,
        requestFor: enableOption,
        isEnable: isEnable,
        setupType: dmsSetup?.setupType ?? SetupType.Shopify,
      },
    }).then((res) => {
      if (enableOption == RequestFor.Price && isEnable) fetchData();
    });
    if (enableOption == RequestFor.Price) {
      setProducts(
        products.map((item) =>
          item.id === id ? { ...item, enablePriceSync: isEnable } : item,
        ),
      );
    } else if (enableOption == RequestFor.Stock) {
      setProducts(
        products.map((item) =>
          item.id === id ? { ...item, enableStockSync: isEnable } : item,
        ),
      );
    } else if (enableOption == RequestFor.Catalog) {
      setProducts(
        products.map((item) =>
          item.id === id ? { ...item, enableCatalogSync: isEnable } : item,
        ),
      );
    }
  };
  return (
    <>
      <Container maxWidth={false}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={8}>
            <Grid item xs={4} key={1}>
              <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
                Product Manager
              </Typography>
            </Grid>
            <Grid item xs={8} key={2}>
              <Grid container sx={{ justifyContent: "right" }} spacing={2}>
                <Grid item key={1}>
                  <Typography
                    sx={{ fontWeight: "bold", pt: "5px" }}
                    variant="subtitle2"
                    gutterBottom
                  >
                    Apply Rule to Selected Items:
                  </Typography>
                </Grid>
                <Grid item key={2}>
                  <Button
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    disabled={selectedRows.length === 0 ? true : false}
                    color="warning"
                    variant="contained"
                    size="small"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    endIcon={<KeyboardArrowDownIcon />}
                  >
                    Price
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={openPriceMenu}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    {hasPriceLevels && (
                      <>
                        <MenuItem
                          onClick={() => {
                            setOpenPriceRule(true);
                          }}
                        >
                          Price Rule
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setOpenResetPrice(true);
                          }}
                        >
                          Reset Price
                        </MenuItem>
                      </>
                    )}
                    {hasPlatformFeatureAccess(
                      dmsSetup?.setupType,
                      PlatformFeature.HidePrice,
                    ) && (
                      <>
                        {" "}
                        <MenuItem
                          disabled={
                            Boolean(anchorEl) && !hasNotHiddenPriceProduct()
                          }
                          onClick={() => {
                            setIsOperationRunning(false);
                            setHideValue(true);
                            setOpenHidePrice(true);
                          }}
                        >
                          Hide Price
                        </MenuItem>
                        <MenuItem
                          disabled={
                            Boolean(anchorEl) && !hasHiddenPriceProduct()
                          }
                          onClick={() => {
                            setIsOperationRunning(false);
                            setHideValue(false);
                            setOpenHidePrice(true);
                          }}
                        >
                          Show Price
                        </MenuItem>{" "}
                      </>
                    )}
                  </Menu>
                  {hasPromotionsSubscription && (
                    <Button
                      color="warning"
                      sx={{ ml: 2 }}
                      variant="contained"
                      size="small"
                      onClick={() => {
                        navigate("/Promotions");
                      }}
                    >
                      Promotions
                    </Button>
                  )}
                  <Button
                    disabled={selectedRows.length === 0 ? true : false}
                    color="warning"
                    sx={{
                      ml: 2,
                      display: IsShopifySetup(dmsSetup?.setupType)
                        ? "inline-flex"
                        : "none",
                    }}
                    variant="contained"
                    size="small"
                    onClick={(e) => {
                      setOpenStockForm(true);
                    }}
                  >
                    Out of Stock Selling
                  </Button>
                  <Button
                    disabled={selectedRows.length === 0 ? true : false}
                    color="warning"
                    sx={{ ml: 2 }}
                    variant="contained"
                    size="small"
                    onClick={() => {
                      setDeleteConfirm(true);
                    }}
                  >
                    Delete
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap={1.5}
          >
            {hasPriceLevels && (
              <>
                <Typography
                  sx={{ fontWeight: "bold", pt: "5px" }}
                  variant="subtitle2"
                  gutterBottom
                >
                  {productType == 0 ? "Wholegoods" : "Parts"} default price
                  level:
                </Typography>
                {priceOptions
                  .filter(
                    (x) =>
                      x.type ===
                      PricingType[
                        value === "Wholegoods"
                          ? (dmsSetup?.priceType ?? "Price")
                          : (dmsSetup?.partsPriceType ?? "Price")
                      ],
                  )
                  .map((option) => (
                    <Typography fontSize="0.9rem">{option.label}</Typography>
                  ))}
              </>
            )}
          </Box>
        </Box>

        {!hasWholegoods && !hasParts && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            Your subscription tier does not include access to any product type.
            Please contact your administrator to upgrade your subscription.
          </Alert>
        )}

        <Card>
          <CardContent sx={{ padding: 0, paddingBottom: "0px !important" }}>
            <TabContext value={value.toString()}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleTabChange}
                  aria-label="lab API tabs example"
                  className="custom-tab-list"
                >
                  {productTypes?.some((n) => n === "Wholegoods") &&
                    hasWholegoods && (
                      <Tab label={"Wholegoods"} value={"Wholegoods"} />
                    )}
                  {productTypes?.some((n) => n === "Parts") && hasParts && (
                    <Tab label={"Parts"} value={"Parts"} />
                  )}
                </TabList>
              </Box>

              {hasWholegoods && (
                <TabPanel value="Wholegoods" style={{ padding: 0 }}>
                  <ServerAppGridPro
                    data={syncProductResult.isLoading ? [] : products}
                    columns={GetAppGridColumns(
                      filterColumnsBySetupType(
                        columns.filter((col) => {
                          if (col.field === "location" && !hasQohByLocation) {
                            return false;
                          }
                          return true;
                        }),
                        dmsSetup?.setupType ?? SetupType.Shopify,
                      ),
                      WGgridSetting?.columnVisibilityModel,
                    )}
                    isLoading={syncProductResult.isLoading}
                    selectedRows={selectedRows}
                    onSelect={(newSelection: any) => {
                      setSelectedRows(newSelection);
                    }}
                    paging={paging}
                    setPaging={setPaging}
                    totalRecords={productsCount}
                    keepNonExistentRowsSelected={false}
                    gridId={AppGridId.Product_Manager_Wholegoods}
                    height={"70vh"}
                  ></ServerAppGridPro>
                </TabPanel>
              )}
              {hasParts && (
                <TabPanel value="Parts" style={{ padding: 0 }}>
                  <ServerAppGridPro
                    data={syncProductResult.isLoading ? [] : products}
                    columns={GetAppGridColumns(
                      filterColumnsBySetupType(
                        partsColumns.filter(
                          (col) =>
                            !(col.field === "location" && !hasQohByLocation),
                        ),
                        dmsSetup?.setupType ?? SetupType.Shopify,
                      ),
                      PartgridSetting?.columnVisibilityModel,
                    )}
                    isLoading={syncProductResult.isLoading}
                    selectedRows={selectedRows}
                    onSelect={(newSelection: any) => {
                      setSelectedRows(newSelection);
                    }}
                    paging={paging}
                    setPaging={setPaging}
                    totalRecords={productsCount}
                    keepNonExistentRowsSelected={false}
                    gridId={AppGridId.Product_Manager_Parts}
                    height={"70vh"}
                  ></ServerAppGridPro>
                </TabPanel>
              )}
            </TabContext>
          </CardContent>
        </Card>
      </Container>
      {openPriceRule && (
        <PriceRule
          handleClose={handleClosePriceRule}
          productType={
            value === "Wholegoods" ? ProductType.Wholegoods : ProductType.Parts
          }
          productIds={selectedRows ?? []}
          isOpen={openPriceRule}
        />
      )}
      <Dialog open={openStockForm} fullWidth>
        <DialogTitle sx={{ textAlign: "center" }}>Stock Decision</DialogTitle>
        <DialogContent>
          <FormLabel id="demo-controlled-radio-buttons-group">
            Do you want to sell these items even if it's out of stock?
          </FormLabel>
          <Stack
            direction="row"
            spacing={1}
            justifyContent="center"
            alignItems="center"
            mt={3}
          >
            <Typography>No</Typography>
            <Switch
              aria-labelledby="demo-controlled-radio-buttons-group"
              checked={checked}
              name="status"
              onChange={handleDecisionChange}
              inputProps={{ "aria-label": "controlled" }}
            />
            <Typography>Yes</Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleStockDecisionSubmit}
            disabled={setStockDecisionMutationResult.isLoading}
            endIcon={
              setStockDecisionMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" color="inherit" />
              ) : null
            }
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog fullWidth open={deleteConfirm}>
        <DialogTitle style={{ textAlign: "center" }}>
          Confirm to delete
        </DialogTitle>
        <DialogContent>Are you sure to delete selected items?</DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setDeleteConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={handleDeleteSubmit}
            disabled={deleteBulkProductsMutationResult.isLoading}
            endIcon={
              deleteBulkProductsMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openHidePrice}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          style={{ textAlign: "center" }}
          id="draggable-dialog-title"
        >
          <Typography color="primary" sx={{ fontWeight: "bold" }}>
            Confirm to {hideValue ? "Hide" : "Show"} Price
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>Are you sure to perform this action?</Typography>
          <br></br>
          <Alert severity="info" sx={{ fontSize: "small" }}>
            Prices and <b>Add to Cart</b> buttons will{" "}
            {hideValue ? "be hidden" : "be shown"} for selected products on
            website.
          </Alert>
          {isOperationRunning ? (
            <Alert sx={{ mt: 1 }} severity="warning">
              A bulk operation for price updates is already running. Please wait
              for a while to complete it!
            </Alert>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setOpenHidePrice(false);
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={hidePriceMutationMutationResult.isLoading}
            endIcon={
              hidePriceMutationMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
            onClick={handleHidePrice}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openPrices}
        onClose={handleClose}
        PaperProps={{ style: { minHeight: "40vh", maxHeight: "90vh" } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: "2px",
          }}
        >
          <Typography color="primary" sx={{ fontWeight: "bold" }}>
            Product Level Price Setting
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Table aria-label="prices table">
            <TableBody>
              {priceOptions
                .filter(
                  ({ key }) =>
                    !isValueNullOrZero(selectedRowData?.aggregatePrices?.[key]),
                )
                .map(({ label, key, type }) => (
                  <StyledTableRow
                    key={key}
                    sx={{ bgcolor: handleGetRowColor(type) }}
                  >
                    <StyledTableCell width="40%">{label}</StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.[key]?.toFixed(2) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.priceType === PricingType[type] &&
                      !selectedRowData?.activePromotion ? (
                        <Chip label="Active" color="success" size="small" />
                      ) : (
                        <Button
                          sx={{ lineHeight: 1.4, fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            const price =
                              selectedRowData?.aggregatePrices?.[key];
                            const compareAtPrice =
                              selectedRowData?.price >
                              selectedRowData?.aggregatePrices?.[key]
                                ? selectedRowData.price
                                : selectedRowData?.aggregatePrices?.[key];
                            if (selectedRowData?.activePromotion) {
                              setOnPromotionConfirm(
                                () => () =>
                                  handleUpdatePrice(
                                    type,
                                    price,
                                    compareAtPrice,
                                  ),
                              );
                            } else {
                              handleUpdatePrice(type, price, compareAtPrice);
                            }
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === type &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              <StyledTableRow sx={{ height: 40 }}>
                <StyledTableCell
                  sx={{ color: "primary", fontWeight: "bold" }}
                  align="center"
                  colSpan={3}
                >
                  <Tooltip title="After resetting, selected default price level will be applied on this product">
                    <Button
                      disabled={updatePriceMutationResult.isLoading}
                      sx={{ height: 25, fontSize: "0.7125rem" }}
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => {
                        const priceType =
                          productType === 0
                            ? (dmsSetup?.priceType ?? PricingType.Price)
                            : (dmsSetup?.partsPriceType ?? PricingType.Price);

                        const selectedPrice = handleGetProductPrice(
                          selectedRowData,
                          priceType,
                        );
                        if (selectedRowData?.activePromotion) {
                          setOnPromotionConfirm(
                            () => () =>
                              handleUpdatePrice(
                                priceType,
                                selectedPrice,
                                selectedRowData?.price > selectedPrice
                                  ? selectedRowData.price
                                  : selectedPrice,
                              ),
                          );
                        } else {
                          handleUpdatePrice(
                            priceType,
                            selectedPrice,
                            selectedRowData?.price > selectedPrice
                              ? selectedRowData.price
                              : selectedPrice,
                          );
                        }
                      }}
                    >
                      {updatePriceMutationResult.isLoading && isResetRequest ? (
                        <CircularProgress size="1.2rem" color="inherit" />
                      ) : (
                        "Reset Price"
                      )}
                    </Button>
                  </Tooltip>
                </StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
          {hasPromotionsSubscription ? (
            <PromotionsTable
              selectedRowData={selectedRowData}
              callback={fetchData}
              setOpenPrices={setOpenPrices}
              setIsResetRequest={setIsResetRequest}
            />
          ) : (
            selectedRowData?.activePromotion && (
              <Alert severity="info">
                This item has an active promotion which will end on{" "}
                {formatDate(selectedRowData?.activePromotion?.endDate)}. You can
                apply any price level, once the promotion ends, the selected
                price will be applied automatically.
              </Alert>
            )
          )}
        </DialogContent>
      </Dialog>

      <Dialog
        open={openShopifyDetails}
        fullWidth={true}
        maxWidth="lg"
        disableEnforceFocus={true}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 0,
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <h4>Website Product Details</h4>
          <IconButton
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ width: "100%" }}>
          <ShopifyProductDetails
            externalProductId={selectedRowData?.externalProductId}
            aggregateId={selectedRowData?.id} //aggregateId decides at backend if need to update catalog sync bit or not
            setOpenShopifyDetails={setOpenShopifyDetails}
            setShowAlertMessage={setShowAlertMessage}
            setShowSaveAlert={setShowSaveAlert}
            handleUpdateMatchingType={handleUpdateProductMatchingType}
          ></ShopifyProductDetails>
        </DialogContent>
      </Dialog>
      <Dialog open={openRevertCustom} fullWidth onClose={handleClose}>
        <DialogTitle>Confirm to Revert Custom</DialogTitle>
        <DialogContent>
          Are you sure you want to remove your custom changes and use details
          from Catalog?
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            autoFocus
            onClick={() => {
              setOpenRevertCustom(false);
            }}
          >
            Keep Custom
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleRevertCustomDetails}
            disabled={revertCustomDetailsMutationResult.isLoading}
            endIcon={
              revertCustomDetailsMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
          >
            Use Catalog
          </Button>
        </DialogActions>
      </Dialog>
      <SnackBarPopup
        severity="success"
        message={showAlertMessage}
        onClose={() => setShowSaveAlert(false)}
        open={showSaveAlert}
        autoHideDuration={3000}
      ></SnackBarPopup>
      <Dialog fullWidth open={productDeleteConfirm}>
        <DialogTitle>Confirm to Delete</DialogTitle>
        <DialogContent>
          {`This action will delete this item from TargetWeb${
            selectedRowData?.isExistingProduct
              ? ""
              : IsShopifySetup(dmsSetup?.setupType)
                ? " and Shopify"
                : dmsSetup?.setupType === SetupType.BigCommerce
                  ? " and BigCommerce"
                  : ""
          }.`}
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              setProductDeleteConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleDeleteProduct}
            disabled={deleteBulkProductsMutationResult.isLoading}
            endIcon={
              deleteBulkProductsMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog fullWidth open={openResetPrice} onClose={handleClose}>
        <DialogTitle style={{ textAlign: "center" }}>
          <Typography color="primary" sx={{ fontWeight: "bold" }}>
            Reset Price Setting
          </Typography>
        </DialogTitle>
        <DialogContent>
          Are you sure you want to reset the price setting of selected items?
          <Alert sx={{ mt: 2 }} severity="warning">
            This action will update the <b>price</b> and <b>price type</b> with
            selected default price level.
          </Alert>
          {errorMessage && (
            <Alert sx={{ mt: 2 }} severity="warning">
              {errorMessage}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="outlined" onClick={handleClose}>
            No
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleResetPrice}
            disabled={resetPriceSyncMutationResult.isLoading}
            endIcon={
              resetPriceSyncMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Popover
        open={Boolean(locationPopoverAnchorEl)}
        anchorEl={locationPopoverAnchorEl}
        onClose={handleCloseLocationPopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, minWidth: 260 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 1,
            }}
          >
            <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
              Location
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: "bold", textAlign: "right" }}
            >
              Stock
            </Typography>
          </Box>
          {locationPopoverStocks.map((locationStock, index: number) => (
            <Box
              key={`${locationStock.name}-${index}`}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                py: 0.25,
              }}
            >
              <Typography variant="body2">{locationStock.name}</Typography>
              <Typography variant="body2" sx={{ textAlign: "right" }}>
                {locationStock.stock}
              </Typography>
            </Box>
          ))}
        </Box>
      </Popover>
      <AppConfirmDialog
        isOpen={!!onPromotionConfirm}
        handleClose={() => setOnPromotionConfirm(null)}
        headerText="Active Promotion Warning"
        bodyText="There is an active promotion, Do you want to cancel it?"
        onSuccess={() => {
          onPromotionConfirm?.();
          setOnPromotionConfirm(null);
        }}
        onFail={() => setOnPromotionConfirm(null)}
      />
    </>
  );
};

const PromotionsTable: React.FC<{
  selectedRowData?: any;
  callback: () => void;
  setOpenPrices: any;
  setIsResetRequest: any;
}> = ({ selectedRowData, callback, setOpenPrices, setIsResetRequest }) => {
  const [applyPromotionById, applyPromotionByIdResult] =
    useApplyPromotionByIdMutation();
  const [loadingPromoId, setLoadingPromoId] = React.useState<string | null>(
    null,
  );
  const dealerTz = useSelector(
    (state: AppState) =>
      state.authReducer.dmsSetup?.dealerTimeZoneIanaId ?? "UTC",
  );
  if (
    !selectedRowData ||
    !selectedRowData.productPromotions ||
    selectedRowData.productPromotions.length === 0
  )
    return null;
  var promotions = selectedRowData?.productPromotions ?? [];

  return (
    <Table
      aria-label="promotions table"
      sx={{ tableLayout: "fixed", width: "100%" }}
    >
      <TableBody>
        <StyledTableRow>
          <StyledTableCell sx={{ minWidth: 150 }}>Name</StyledTableCell>
          <StyledTableCell align="right" sx={{ minWidth: 100 }}>
            Base Price
          </StyledTableCell>
          <StyledTableCell align="right" sx={{ minWidth: 100 }}>
            Sale Price
          </StyledTableCell>
          <StyledTableCell align="center" sx={{ minWidth: 100 }}>
            Start Date
          </StyledTableCell>
          <StyledTableCell align="center" sx={{ minWidth: 100 }}>
            End Date
          </StyledTableCell>
          <StyledTableCell align="center" sx={{ minWidth: 80 }}>
            Status
          </StyledTableCell>
        </StyledTableRow>
        {[...promotions]
          .sort((a, b) => {
            if (a.status === b.status) return 0;

            if (a.status === "Active") return -1;
            if (b.status === "Active") return 1;

            if (a.status === "Canceled") return -1;
            if (b.status === "Canceled") return 1;

            return 0;
          })
          .map((promo: any) => {
            const isActive = promo.status === "Active";
            let salePrice = getCalculatedSalePrice(
              selectedRowData?.price,
              promo.salePrice,
              promo.discount,
            );
            return (
              <StyledTableRow
                key={promo.id}
                sx={{
                  bgcolor: isActive ? "rgb(237, 247, 237)" : "inherit",
                  opacity: isActive ? 1 : "inherit",
                }}
              >
                <StyledTableCell>
                  <TruncatedCellWithTooltip value={promo.name} />
                </StyledTableCell>
                <StyledTableCell align="right">
                  {promo.basePriceType}
                </StyledTableCell>
                <StyledTableCell align="right">
                  <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={0.5}
                  >
                    {salePrice <= 0 ? (
                      <Tooltip title="Sale price is zero or less than zero. This promotion won't be activated or published online.">
                        <WarningIcon color="error" fontSize="small" />
                      </Tooltip>
                    ) : (
                      salePrice.toFixed(2)
                    )}
                  </Box>
                </StyledTableCell>
                <StyledTableCell align="center">
                  {promo.startDate
                    ? dayjs
                        .utc(promo.startDate)
                        .tz(dealerTz)
                        .format("MM/DD/YYYY")
                    : "N/A"}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {promo.endDate
                    ? dayjs.utc(promo.endDate).tz(dealerTz).format("MM/DD/YYYY")
                    : "N/A"}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {promo.status === "Canceled" ? (
                    <Button
                      sx={{ lineHeight: 1.4, fontSize: "0.7125rem" }}
                      disabled={
                        salePrice <= 0.0 || applyPromotionByIdResult.isLoading
                      }
                      variant="contained"
                      color="warning"
                      size="small"
                      onClick={() => {
                        setLoadingPromoId(promo.aggregatePromotionId);
                        applyPromotionById({
                          aggregatePromotionalPriceId:
                            promo.aggregatePromotionId,
                        })
                          .then((res: any) => {
                            if (res && res.data) {
                              if (res.data.status === 200) {
                                callback();
                                setOpenPrices(false);
                                setIsResetRequest(false);
                              }
                            }
                          })
                          .finally(() => {
                            setLoadingPromoId(null);
                          });
                      }}
                    >
                      {loadingPromoId === promo.aggregatePromotionId ? (
                        <CircularProgress size="1rem" color="inherit" />
                      ) : (
                        "Apply"
                      )}
                    </Button>
                  ) : (
                    <Chip
                      label={
                        promo.status === "Inactive" ? "Pending" : promo.status
                      }
                      color={isActive ? "success" : "warning"}
                      size="small"
                    />
                  )}
                </StyledTableCell>
              </StyledTableRow>
            );
          })}
      </TableBody>
    </Table>
  );
};

export default ProductManagement;
